import { defineMessages, type MessageDescriptor } from 'react-intl';

type MessageKeys =
	| 'sideNavLabel'
	| 'contentHeader'
	| 'connectAppsHeading'
	| 'connectAppsDescription'
	| 'searchAppsPlaceholder';

export const messages: Record<MessageKeys, MessageDescriptor> = defineMessages({
	sideNavLabel: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.discovery.label',
		defaultMessage: 'Apps',
		description: 'Side nav item label for the app discovery page in the Rovo Settings modal',
	},
	contentHeader: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.discovery.content-header',
		defaultMessage: 'Rovo settings',
		description: 'Content header displayed at the top of the app discovery section',
	},
	connectAppsHeading: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.discovery.connect-apps-heading',
		defaultMessage: 'Connect apps',
		description: 'Heading for the app discovery section where users can connect third-party apps',
	},
	connectAppsDescription: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.discovery.connect-apps-description',
		defaultMessage:
			'Connect admin-approved apps to get richer, more accurate answers in Search and Chat.',
		description: 'Description text explaining the benefit of connecting apps to Rovo',
	},
	searchAppsPlaceholder: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.discovery.search-apps-placeholder',
		defaultMessage: 'Search apps',
		description: 'Placeholder text for the search input field in the app discovery section',
	},
});
